import React from "react";
import { useDispatch } from "react-redux";
import { LoginSocialFacebook } from "reactjs-social-login";
import { setFacebookProfileData } from "./FacebookAdsSlice";

const REDIRECT_URI = "http://localhost:3000/funnel-leakage";
// const REDIRECT_URI = "https://dashboard.causalfunnels.com/funnel-leakage";

const FacebookAuth = () => {
  const dispatch = useDispatch();
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 border-b-2 py-3">
      <h3 className="text-lg font-semibold">Facebook ads data</h3>
      <LoginSocialFacebook
        appId={process.env.REACT_APP_FB_APP_ID || "759484216120692"}
        fieldsProfile={"id,name,picture,email,adaccounts{insights,name}"}
        scope={"email,ads_management,ads_read"}
        version={"v14.0"}
        onLogoutSuccess={() => console.log("CF -- FB Logout")}
        redirect_uri={REDIRECT_URI}
        onResolve={({ provider, data }) => {
          dispatch(setFacebookProfileData(data));
        }}
        onReject={(err) => {
          console.log(err);
        }}
      >
        <button className="bg-indigo-500 hover:bg-indigo-600 text-white py-1.5 px-4 rounded-md cursor-pointer w-max">
          Login to view
        </button>
      </LoginSocialFacebook>
    </div>
  );
};

export default FacebookAuth;
